import React from 'react'
import TablePrice from '../../components/TablePrice/TablePrice';

const PricePage = () => {
    return (
        <>
            <TablePrice />
        </>
    )
}

export default PricePage;